import * as React from 'react';
import { getSsoRedirectUrl } from '../getSsoRedirectUrl';
import { ItaliaButton } from '../italia-button/ItaliaButton';

const eidasIco = require('./img/ficep-it-eidas-db.svg').default;

export interface EidasLoginButtonProps {}

/**
 * Pulsante eIDAS
 */
export function EidasLoginButton(props: EidasLoginButtonProps) {
  return (
    <a href={getSsoRedirectUrl('spid', 'eidas')}>
      <ItaliaButton image={eidasIco} text="Login with eIDAS" />
    </a>
  );
}
